module.exports = __webpack_public_path__ + "img/meguru05.9edd8ecd.png";